import {Component, OnInit} from '@angular/core';
import {GeneralService} from "../../../../services/generalService";
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {DICTIONARY} from "../../../../dictionary";
import _ from 'lodash';
import {CollaborationProtectionService} from '../../../../services/collaborationProtectionService';


@Component({
  selector: 'app-collaboration-protection-users',
  templateUrl: './collaboration-protection-users.component.html'
})
export class CollaborationProtectionUsersComponent implements OnInit {
	constructor(private gs:GeneralService,
				private cps:CollaborationProtectionService,
				private rs:RouteService,
				private ns:NotificationService) {
	}

	_ = _;
	dic = DICTIONARY;
	filterData;
	mailboxes;
	loadingUsersInProcess;
	config;
	assetsByUser: Record<string, any[]> = {};
	currentUserAssetsPopup;
	currentAssetInfoObj;

	linkScopeTooltips: Record<string, string> = {
		anonymous: 'Anyone with the link can access (no login required)',
		organization: 'All users in your company can access (must sign in)',
		users: 'Only users with existing access (must sign in)',
		external: 'At least one or more external user has an access to this file'
	};

	ngOnInit() {
		this.rs.getCollaborationConfiguration().then((response) => {
			this.config = response;
			Promise.all([this.getCollaborationUsersMailboxes(), this.getCollaborationAssets()]).then(() => {
				this.mailboxes.forEach(mailboxObj => {
					mailboxObj.assets = this.assetsByUser[mailboxObj.email] || [];
					this.parseUserFindings(mailboxObj);
				});
			});
		});

		this.initFilters();
	}

	getCollaborationUsersMailboxes = () => {
		this.loadingUsersInProcess = true;
		return this.rs.getCollaborationUsersMailboxes().then((response) => {
			this.mailboxes = response || [];
			this.mailboxes.forEach((mailboxObj) => {
				mailboxObj.is_protected = mailboxObj.is_protected || this.config.collaboration_protection.microsoft?.protect_all;

				if (this.assetsByUser) {
					mailboxObj.assets = this.assetsByUser[mailboxObj.email] || [];
					this.parseUserFindings(mailboxObj);
				}
			});

			this.loadingUsersInProcess = false;
		}, (err) => {
			this.loadingUsersInProcess = false;
		});
	}

	getCollaborationAssets = () => {
		return this.rs.getCollaborationAssets().then((response) => {
			const assets = response;
			assets.forEach((assetObj) => {
				this.cps.parseResourceName(assetObj.resource_id);
				this.parseAssetDetails(assetObj);
			});

			this.assetsByUser = _.groupBy(assets, (assetObj) => assetObj.user);
		}, (err) => {
		});
	}

	parseAssetDetails = (assetObj) => {
		if (assetObj.sensitivity_info) {
			assetObj._topSensitiveTypes = (assetObj.sensitivity_info.sensitive_types || [])
				.filter(t => t.score)
				.sort((a, b) => (b.score || 0) - (a.score || 0))
				.slice(0, 3)
				.map(t => t.sensitive_type);
		}

		if (assetObj.malicious_info) {
			assetObj._maliciousSubCategory = (assetObj.malicious_info.sub_status || [])
				.map(s => s.message)
				.slice(0, 2);
		}
	}

	parseUserFindings = (mailboxObj) => {
		const assets = mailboxObj.assets || [];
		const maliciousAssets = assets.filter(a => a.category === 'Malicious');
		const dlpAssets = assets.filter(a => a.category === 'DLP');
		mailboxObj._findings = {
			maliciousCount: maliciousAssets.length,
			dlpCount: dlpAssets.length,
			topMaliciousStatus: maliciousAssets[0]?.malicious_info?.status || 'Malicious',
			topDlpScore: dlpAssets.length ? Math.max(...dlpAssets.map(a => a.sensitivity_info?.score ?? 0)) : 0,
		};
	}

	sensitivityScoreColor(score: number) {
		if (score >= 5) return '#FF4136';
		if (score >= 4) return '#FF851B';
		if (score >= 1) return 'darkorange';
		return 'limegreen';
	}

		initFilters = () => {
		const filters = {
			status: [this.dic.CONSTANTS.collaborationMailboxStatus.protect, this.dic.CONSTANTS.collaborationMailboxStatus.exposed],
		};

		this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.collaborationUsers,
			filters: filters,
			initFiltersFunction: this.initFilters,
		};
	};

	exportToCsv = (sortBy) => {
		if (!this.mailboxes?.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}
		let csvString = 'User,License,Status,Findings,Last Activity\n';
		let rows = this.mailboxes.filter(e => !e.hide);
		if (sortBy) {
			rows = this.gs.sortTable(rows, sortBy);
		}
		rows.forEach(itm => {
			const findingsParts = [];
			if (itm._findings?.maliciousCount) {
				findingsParts.push(`${itm._findings.maliciousCount} Malicious`);
			}
			if (itm._findings?.dlpCount) {
				findingsParts.push(`${itm._findings.dlpCount} DLP (top score: ${itm._findings.topDlpScore})`);
			}
			const findings = findingsParts.join(' | ');
			csvString += `${itm.email},${itm.license},${itm.is_protected ? 'Protected' : 'Disabled'},${findings},${itm.last_updated}\n`;
		});
		this.gs.exportCsv(csvString, 'collab_users.csv');
	}

	searchUsers = (searchTerm, activeFilters) => {
		this.mailboxes.forEach(record => {
			if (searchTerm) {
				const isFound = searchTextExecute(record, searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			// filter
			if (activeFilters) {
				// need to match all filter types
				let numFilterToMatch = Object.keys(activeFilters).length;

				if (activeFilters['status'] && activeFilters['status'].length) {
					if (activeFilters['status'].includes(this.dic.CONSTANTS.collaborationMailboxStatus.protect) && record.is_protected) {
						numFilterToMatch--;
					}
					if (activeFilters['status'].includes(this.dic.CONSTANTS.collaborationMailboxStatus.exposed) && !record.is_protected) {
						numFilterToMatch--;
					}
				}

				if (numFilterToMatch) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}

	showAssetActionsInPopup = (assetObj) => {
		return ['View info'];
	}

	selectAssetActionInPopup = (assetObj, action) => {
		switch (action) {
			case 'View info':
				this.currentAssetInfoObj = assetObj;
				break;
		}
	}

	showMailboxActions = (mailboxObj) => {
		return [
			'Show Assets',
			mailboxObj.is_protected ?
				this.dic.CONSTANTS.collaborationMailboxAction.disable.display :
				this.dic.CONSTANTS.collaborationMailboxAction.enable.display,
			this.dic.CONSTANTS.collaborationMailboxAction.delete.display,
		];
	}

	selectMailboxAction =  (mailbox, action) => {
		if (!mailbox) {
			return;
		}

		switch (action) {
			case 'Show Assets':
				this.currentUserAssetsPopup = mailbox;
				break;

			case this.dic.CONSTANTS.collaborationMailboxAction.enable.display:
				this.enableApiProtection([mailbox]);
				break;

			case this.dic.CONSTANTS.collaborationMailboxAction.disable.display:
				this.disableApiProtection([mailbox]);
				break;

			case this.dic.CONSTANTS.collaborationMailboxAction.delete.display:
				this.deleteCollaborationMailbox([mailbox]);
				break;
		}
	}

	showMultipleMailboxesActions = () => {
		return [
			this.dic.CONSTANTS.collaborationMailboxAction.enable.display,
			this.dic.CONSTANTS.collaborationMailboxAction.disable.display,
			this.dic.CONSTANTS.collaborationMailboxAction.delete.display,
		];
	};


	selectMultipleMailboxesAction = (selectedItems, action) => {
		switch (action) {
			case this.dic.CONSTANTS.collaborationMailboxAction.enable.display:
				this.enableApiProtection(selectedItems);
				break;

			case this.dic.CONSTANTS.collaborationMailboxAction.disable.display:
				this.disableApiProtection(selectedItems);
				break;

			case this.dic.CONSTANTS.collaborationMailboxAction.delete.display:
				this.deleteCollaborationMailbox(selectedItems);
				break;
		}
	};

	syncMailboxes = () => {
		const actionInfo = {
			action: this.dic.CONSTANTS.collaborationMailboxAction.syncMailboxes.value
		};
		this.rs.configureCollaborationMailbox('', actionInfo).then((response) => {
			this.ns.showInfoMessage('We are syncing your user data, this operation can take a few minutes. Refresh this page to see an updated user list when the sync process is updated.');
		}, (err) => {
		});
	}

	deleteCollaborationMailbox = (mailboxes) => {
		this.gs.showPopup({
			title: `Delete Mailbox`,
			subTitle: mailboxes.length > 1 ? `You are about to delete ${mailboxes.length} mailboxes` : `You are about to delete the mailbox ${mailboxes[0].email}`,
			body: [`Text and files related directly to this mailbox will no longer be scanned.`],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Confirm',
			doneCb: () => {
				mailboxes.forEach((mailboxObj) => {
					this.rs.deleteCollaborationMailbox(mailboxObj.email).then((response) => {
						this.mailboxes = this.mailboxes.filter(m => m.email !== mailboxObj.email);
						this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
					}, (err) => {
					});
				});
			}
		});
	}

	enableApiProtection = (mailboxes) => {
		if (this.config.collaboration_protection.microsoft?.protect_all) {
			return;
		}

		mailboxes.forEach((mailboxObj) => {
			const actionInfo = {
				action: this.dic.CONSTANTS.collaborationMailboxAction.enable.value
			};
			this.rs.configureCollaborationMailbox(mailboxObj.email, actionInfo).then((response) => {
				mailboxObj.is_protected = true;
				this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			}, (err) => {
			});
		});
	}

	disableApiProtection = (mailboxes) => {
		if (this.config.collaboration_protection.microsoft?.protect_all) {
			this.ns.showErrorMessage('Cannot disable protection. all users are set to be protected');
			return;
		}

		this.gs.showPopup({
			title: `Disable Protection`,
			subTitle: mailboxes.length > 1 ? `You are about to disable collaboration protection for ${mailboxes.length} mailboxes` : `You are about to disable collaboration protection for the mailbox ${mailboxes[0].email}`,
			body: [`Text and files related directly to this mailbox will no longer be scanned.`],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Confirm',
			doneCb: () => {
				mailboxes.forEach((mailboxObj) => {
					const actionInfo = {
						action: this.dic.CONSTANTS.collaborationMailboxAction.disable.value
					};
					this.rs.configureCollaborationMailbox(mailboxObj.email, actionInfo).then((response) => {
						mailboxObj.is_protected = false;
						this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
					}, (err) => {
					});
				});
			}
		});
	}
}

function searchTextExecute(userObj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return (userObj.email?.toLowerCase().indexOf(searchTerm) > -1 ||
		userObj.name?.toLowerCase().indexOf(searchTerm) > -1);
}
